// extracted by mini-css-extract-plugin
export var avatarContainer = "_4t-1";
export var largeAvatarContainer = "_4t-2";
export var smallAvatarContainer = "_4t-0";